<template>
    <div class="sendMessage">
        <div v-for="(item, key) in messages"
             :class="{user: isType('user',item), agent: isType('agent',item), system: isType('system',item), 'user-share-cart': isType('user_share_cart', item)}"
             :key="item.id">
            <div class="date" v-html="parseItemDate(item)"></div>
            <div v-if="isType('user_share_cart', item)" class="message-wrapper d-flex">
                <div class="text d-flex">
                    <i class="waiting-icon icon-message-confirmation success-color"></i>
                    <span v-html="$gettext('Su carrito de compra ha sido compartido con el agente.')"></span>
                </div>
            </div>
            <div v-else class="message-wrapper d-flex"
                 :class="{lastUser: key === lastMessageOfType.user, lastAgent: key === lastMessageOfType.agent}">
                <div class="user-icon"
                     v-bind:style="isType('agent',item) && agent.avatar ? 'background: url( ' + agent.avatar + ' ) no-repeat center; background-size: cover;' : ''">
                    <div class="user-initial" v-if="isType('user',item)">{{ getInitial }}</div>
                </div>
                <div class="text" v-html="item.text"></div>
            </div>
        </div>
        <div v-for="(writting,idx) in whoIsWritting" :key="writting.id" class="writtingMessage">
            <div :class="idx" v-if="writting">
                <div class="message-wrapper d-flex">
                    <div class="user-icon">
                        <div class="user-initial" v-if="idx == 'user'">{{ getInitial }}</div>
                    </div>
                    <div class="text">
                        <writting-animation/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import WrittingAnimation from './WrittingAnimation.vue'
import {mapState, mapGetters, mapMutations} from "vuex";

export default ({
    name: 'SendMessage',
    components: {
        WrittingAnimation
    },
    props: ['messages'],
    data() {
        return {
            userInitial: null
        }
    },
    created() {
        //this.$store.dispatch('sendAgentMessage', this.$gettextInterpolate( "Hola %{ user }, soy %{ agent }., asistente personal de IKEA, ¿en que puedo ayudarte?",{user:this.$store.state.user.name,agent:this.$store.state.agent.name}));
    },
    methods: {
        ...mapMutations(['messagesSeen']),
        isType(type, item) {
            return (type == 'user' && item.ikind == 1) || (type == 'agent' && item.ikind == 2) || (type == 'system' && item.ikind > 2) || (type == 'user_share_cart' && item.ikind == 10)
        },
        parseItemDate(item) {
            return new Date(item.created_at * 1000).toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3")
        }
    },
    mounted() {
        if(this.isChatOpened){
            this.messagesSeen();
        }
    },
    computed: {
        ...mapState(['user', 'agent', 'system', 'hasNewMessages', 'isChatOpened']),
        ...mapGetters(['isUserLogged']),
        whoIsWritting() {
            return {
                user: this.user.isWritting,
                agent: this.agent.isWritting
            };
        },
        getInitial() {
            return this.userInitial = this.isUserLogged ? this.user.name.substring(0, 1) : "A";
        },
        lastMessageOfType() {
            var a = this.messages.map(el => el.sender ? 'user' : (el.ikind == 2 ? 'agent' : 'system'));
            var res = {agent: a.lastIndexOf('agent'), user: a.lastIndexOf('user')}
            return res;
        },
        agentAvatar() {
            return 'url( ' + this.agent.avatar + ' ) no-repeat center';
        }
    },
    watch: {
        messages(value){
            if(this.hasNewMessages && this.isChatOpened){
                this.messagesSeen();
            }
        }
    }
})
</script>